import { render, staticRenderFns } from "./personnelManagement.vue?vue&type=template&id=2322ce1e&scoped=true"
import script from "./personnelManagement.vue?vue&type=script&lang=js"
export * from "./personnelManagement.vue?vue&type=script&lang=js"
import style0 from "./personnelManagement.vue?vue&type=style&index=0&id=2322ce1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322ce1e",
  null
  
)

export default component.exports